import { CbBankFieldTypes } from 'cbbank/inquiry/fields';

type CbBankFactoringNeedFieldTypes = CbBankFieldTypes['financingNeedPage']['factoringNeedSection'];

export const mapCbBankFactoringNeed = (values: CbBankFactoringNeedFieldTypes) => ({
  annual_factoring_relevant_turnover: values.annualFactoringRelevantTurnover,
  payment_term: values.paymentTerm,
});
